<template>
    <div class="user-billing">
        <template v-if="!isOnlyFreeAndLifetime">
            <transition-group
                name="fade"
                mode="out-in"
            >
                <template v-if="!licenses">
                    <div
                        :key="'loader'"
                        class="loader"
                    >
                        <i class="fas fa-spinner fa-spin loader" />
                    </div>
                </template>
                <template v-else>
                    <license-content key="license-content" settings-page="billing" />
                </template>
            </transition-group>
        </template>
        <template v-else>
            <upgrade-lifetime />
        </template>
        <transition-group
            name="fade"
        >
            <div
                v-if="UIState.isUpdateModalVisible"
                key="updateModal"
                class="modal"
            >
                <update-card />
            </div>
            <resume-subscription-modal
                v-if="UIState.isResumeSubscriptionModalVisible"
                key="resume-subscription"
                :subscription-id="activeSubscription.id"
            />
        </transition-group>
    </div>
</template>

<script>
import UpdateCard from '@/components/Dashboard/Settings/Billing/UpdateCard';
import UpgradeLifetime from '@/components/Dashboard/Settings/Billing/UpgradeLifetime';
import ResumeSubscriptionModal from '@/components/Dashboard/Settings/Billing/ResumeSubscriptionModal';
import LicenseContent from '@/components/Dashboard/Settings/LicenseContent';
import getActiveSubscription from '@/utils/getActiveSubscription';

import { mapState, mapGetters } from 'vuex';

export default {
    components: {
        UpdateCard,
        ResumeSubscriptionModal,
        UpgradeLifetime,
        LicenseContent,
    },

    data: () => ({
        loadedSubscription: false,
    }),

    computed: {
        ...mapState([
            'UIState',
            'user',
            'licenses',
        ]),

        ...mapGetters(['totalLicenseSeats']),

        /**
         * Retrurn true if subscription has more sites than allowed.
         *
         * @returns {boolean} Whether the error is visible.
         */
        isVisible() {
            return this.totalLicenseSeats.used > this.totalLicenseSeats.all;
        },

        /**
         * Get active subscription
         *
         * @returns {object} Subscription
         */
        activeSubscription() {
            return getActiveSubscription(this.user.subscriptions);
        },

        /**
         * Checks if user has only Free and Lifetime Subscription on Billing view
         *
         * @returns {boolean} Condition if has only lifetime and free
         */
        isOnlyFreeAndLifetime() {
            if (! this.isLifetimeSubscriptionSelected) {
                const subscriptions = this.user.subscriptions;
                let lifetimeAndFree = true;

                subscriptions.forEach(subscription => {
                    if ('pro' === subscription.name) lifetimeAndFree = false;
                });

                return lifetimeAndFree;
            }

            return false;
        },
    },
};
</script>
